import React, {FC} from 'react';
import {useEditorLocation} from "../../../editor/editor.hook";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Grid,
    makeStyles
} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import {Form, Formik} from 'formik';
import {FormikTextField} from "../../../form/FormikTextField";
import * as yup from 'yup';
import {useCreateService} from "../redux/services.hook";
import {ServiceDocumentData} from "../redux/types";

const useStyles = makeStyles(theme => ({
    formContainer: {
        paddingBottom: theme.spacing(2)
    },
    successButton: {
        color: theme.palette.success.main
     },
    cancelButton: {
        color: theme.palette.error.main
     }
}));

const validationSchema = yup.object({name: yup.string().required('required').min(2, 'to short')});
const initialValues: ServiceDocumentData = {name: '', active: true, position: 0};

export const CreateServiceDialogForm: FC = () => {
    const classes = useStyles();
    const history = useHistory();
    const {mode} = useEditorLocation();
    const {createService} = useCreateService();
    const [isLoading, setIsLoading] = React.useState(false);

    const dialogOpen = mode === 'create';

    const openDialog = () => history.replace(`${history.location.pathname}?mode=create`);
    const closeDialog = () => history.replace({search: undefined});

    return (
        <>
            <Button
                variant="contained"
                color="primary"
                onClick={openDialog}
            >
                Neu
            </Button>
            <Dialog open={dialogOpen} onClose={closeDialog}>
                <DialogTitle>
                    Neue Dienstleistung
                </DialogTitle>
                <Formik
                    initialValues={initialValues}
                    onSubmit={(dto) => {
                        setIsLoading(true);
                        createService(dto)
                            .then(() => {
                                closeDialog();
                            })
                            .catch(() => {
                            })
                            .finally(() => {
                                setIsLoading(false)
                            })
                    }}
                    validationSchema={validationSchema}
                >
                    {({submitForm, resetForm}) => (
                        <Form>
                            <DialogContent classes={{root: classes.formContainer}}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <FormikTextField fullWidth required name={"name"} label={"Name"} style={{marginBottom: 16}}/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormikTextField fullWidth name={"subtitle"} label={"Subtitel"}/>
                                    </Grid>
                                </Grid>

                            </DialogContent>
                            <DialogActions>
                                {isLoading ?
                                    <CircularProgress/> :
                                    (<>
                                        <Button className={classes.cancelButton} onClick={() => {
                                            closeDialog();
                                            resetForm();
                                        }}>
                                            Abbrechen
                                        </Button>
                                        <Button className={classes.successButton} onClick={submitForm}>
                                            Speichern
                                        </Button>
                                    </>)}
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    )
}
